import { Component, Input, OnInit } from '@angular/core';
import { DocumentLibrary } from '@apps/documents/document.state';
import { Store } from '@ngrx/store';
import { go } from '@platform/router.actions';
import { RootState } from '@root/app.state';
import { map, Observable, of, shareReplay, startWith } from 'rxjs';
import { NavigationService } from '@platform/shared/navigation.service';
import { LoadingService, provideLoadingService } from '@platform/shared/loading.service';
import { DocumentService } from '@apps/documents/document.service';

@Component({
  selector: 'app-document-widget',
  templateUrl: './document-widget.component.html',
  styleUrls: ['./document-widget.component.scss'],
  providers: [provideLoadingService()],
})
export class DocumentWidgetComponent implements OnInit {
  @Input({ required: true }) customerSpaceId!: string;
  public readonly displayRowsCount = 6;
  showAll$: Observable<boolean> = of(false);
  public totalCount$!: Observable<number>;
  public documentLibraries$: Observable<DocumentLibrary[]>;
  public navigateLink: string[] | null;

  constructor(
    private store$: Store<RootState>,
    public navigation: NavigationService,
    public loadingService: LoadingService,
    private documentService: DocumentService,
  ) {}

  get navigateLibrariesLink() {
    return ['/', 'customer-spaces', this.customerSpaceId, 'documents', 'libraries'];
  }

  ngOnInit(): void {
    this.documentLibraries$ = this.loadingService.showLoadingUntilCompleted(
      this.documentService.loadDocumentLibraries(this.customerSpaceId).pipe(startWith([]), shareReplay(1)),
    );
    this.totalCount$ = this.documentLibraries$.pipe(map((e) => e.length));
    this.showAll$ = this.totalCount$.pipe(map((total) => total > this.displayRowsCount));
  }

  navigateToDocuments($event: Event, library: DocumentLibrary) {
    this.store$.dispatch(go({ path: ['customer-spaces', this.customerSpaceId, 'documents', library.title, library.name] }));
  }
}
